import SelectedPin from './SelectedPin';
import images from './images';

export default SelectedPin;
export { images };
